import InlineEditableMedia from './InlineEditableMedia'

export default InlineEditableMedia
